<template>
  <div id="matrices-captura">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Carga de matrices mecanizado Captura&nbsp;</v-toolbar-title
        >
        <v-tooltip bottom>
          <span slot="activator"
            ><v-icon dark color="grey" x-small>help</v-icon></span
          >
          <span
            >Deben coincidir los títulos del encabezado en la carga respetando
            mayúsculas y minúsculas. La plantilla contiene algunos datos de
            ejemplo.
          </span>
        </v-tooltip>
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva-matriz
          :apiValidateDocument="apiValidateDocumentRecep"
          :apiSaveDocument="apiSaveDocumentRecep"
          :apiDownloadDocument="apiDownloadDocumentRecep"
          :templateTitle="templateTitleRecep"
          :tipoCarga="tipoCargaRecep"
          :tipo="'Recepción'"
        ></carga-masiva-matriz>
      </v-layout>
      <br />
      <v-layout>
        <carga-masiva-matriz
          :apiValidateDocument="apiValidateDocumentCurso"
          :apiSaveDocument="apiSaveDocumentCurso"
          :apiDownloadDocument="apiDownloadDocumentCurso"
          :templateTitle="templateTitleCurso"
          :tipoCarga="tipoCargaCurso"
          :tipo="'Curso'"
        ></carga-masiva-matriz>
      </v-layout>
      <br />
      <v-layout>
        <carga-masiva-matriz
          :apiValidateDocument="apiValidateDocumentSerie"
          :apiSaveDocument="apiSaveDocumentSerie"
          :apiDownloadDocument="apiDownloadDocumentSerie"
          :templateTitle="templateTitleSerie"
          :tipoCarga="tipoCargaSerie"
          :tipo="'Serie'"
        ></carga-masiva-matriz>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import CargaMasivaMatriz from "@/components/CargaMasivaMatriz.vue";

export default {
  name: "matrices-captura",
  components: {
    CargaMasivaMatriz,
  },
  props: {
    contratoId: Number,
  },
  data() {
    return {
      //----CARGA MASIVA---
      apiValidateDocumentRecep: "",
      apiSaveDocumentRecep: "",
      apiDownloadDocumentRecep: "",
      templateTitleRecep: "",
      tipoCargaRecep: "CSV",

      apiValidateDocumentCurso: "",
      apiSaveDocumentCurso: "",
      apiDownloadDocumentCurso: "",
      templateTitleCurso: "",
      tipoCargaCurso: "CSV",

      apiValidateDocumentSerie: "",
      apiSaveDocumentSerie: "",
      apiDownloadDocumentSerie: "",
      templateTitleSerie: "",
      tipoCargaSerie: "CSV",
    };
  },
  validations: {},
  computed: {},
  created() {
    this.$store.commit("tab_state", "Proceso");
    this.apiValidateDocumentRecep = "/cuadraturas/preProcessMatrizRecep";
    this.apiSaveDocumentRecep = "/cuadraturas/saveFileMatrizRecep";
    this.apiDownloadDocumentRecep = "/cuadraturas/downloadTemplateMatrizRecep/";
    this.templateTitleRecep = "Plantilla_Matriz_Cuadraturas_Recep";

    this.apiValidateDocumentCurso = "/cuadraturas/preProcessMatrizCurso";
    this.apiSaveDocumentCurso = "/cuadraturas/saveFileMatrizCurso";
    this.apiDownloadDocumentCurso = "/cuadraturas/downloadTemplateMatrizCurso/";
    this.templateTitleCurso = "Plantilla_Matriz_Cuadraturas_Curso";

    this.apiValidateDocumentSerie = "/cuadraturas/preProcessMatrizSerie";
    this.apiSaveDocumentSerie = "/cuadraturas/saveFileMatrizSerie";
    this.apiDownloadDocumentSerie = "/cuadraturas/downloadTemplateMatrizSerie/";
    this.templateTitleSerie = "Plantilla_Matriz_Cuadraturas_Serie";
  },
  methods: {},
};
</script>
